import React, { FC, ReactNode, useMemo } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import Tabs, { Tab } from '@adsk/alloy-react-tabs';

import { useFeatureFlag } from '../../components/LaunchDarklyProvider';
import { SCROLL_CONTAINER_ID } from '../../consts';
import i18n from '../../utils/i18n';

type TabType = {
  tab: string;
  path: string;
  label: ReactNode;
};

const ProjectsHeaderTabs: FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { value: translateProjectsHeaderTabs } = useFeatureFlag(
    'translate-projects-header-tabs',
  );

  const tabs = useMemo<TabType[]>(
    () => [
      {
        tab: 'home',
        label: 'My Home',
        path: '/home',
      },
      {
        tab: 'projects',
        label: translateProjectsHeaderTabs ? i18n.t('PROJECTS') : 'Projects',
        path: '/projects',
      },
      {
        tab: 'projectTemplates',
        label: translateProjectsHeaderTabs
          ? i18n.t('PROJECT_TEMPLATES')
          : 'Project Templates',
        path: '/projects/templates',
      },
    ],
    [translateProjectsHeaderTabs],
  );

  const onTabChange = (tab: string) => {
    const nextTab = tabs.find((t) => t.tab === tab);

    const scrollContainer = document.getElementById(SCROLL_CONTAINER_ID);
    if (scrollContainer) scrollContainer.scrollTo(0, 0);

    if (nextTab && nextTab.path) {
      navigate(nextTab.path);
    }
  };

  const activeTab = tabs.find((tab) => pathname === tab.path)?.tab;

  return (
    <Tabs
      className="pendo-banner-target"
      style={{ margin: '32px 0 0 48px' }}
      onChange={onTabChange}
      active={activeTab}
    >
      {tabs.map(({ label, tab }) => (
        <Tab key={tab} label={label} tab={tab} />
      ))}
    </Tabs>
  );
};

export default ProjectsHeaderTabs;
